import React, { forwardRef } from 'react';

const FloatingSelect = forwardRef(({ label, name, value, onChange, options = [], required = false, bgType = 'light' }, ref) => {
    return (
        <div className="form-floating mb-3">
            <select
                id={name}
                name={name}
                className="form-select"
                value={value}
                onChange={onChange}
                required={required}
                ref={ref}
                style={{ paddingLeft: '20px', boxShadow: 'none', fontWeight: '400' }}
            >
                <option value="" disabled hidden>Select {label}</option>
                {options.map((opt, idx) => (
                    <option key={idx} value={opt.value || opt}>{opt.label || opt}</option>
                ))}
            </select>
            <label htmlFor={name}>{label}</label>

            <style>{`
                .form-floating > .form-select:focus ~ label,
                .form-floating > .form-select:not([value=""]) ~ label {
                    color: ${bgType === 'dark' ? '#fff' : '#0C5546'};
                }
                select:-webkit-autofill {
                    box-shadow: 0 0 0px 1000px transparent inset !important;
                    -webkit-text-fill-color: ${bgType === 'dark' ? '#fff' : 'black'} !important;
                    transition: background-color 5000s ease-in-out 0s;
                }
            `}</style>
        </div>
    );
});

export default FloatingSelect;
